import { Box, Icon, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

interface Props {
  visits: number
  withText?: boolean
}

function Visits({ visits, withText = false }: Props) {
  return (
    <Box flexDirection="row" alignItems="center" gap="s4">
      <Icon.Medium color="grey600" icon="eye-visible" />
      <Text.Normal weight="medium" size="200" color="grey600">
        {visits}
      </Text.Normal>
      {withText && (
        <Text.Normal weight="medium" size="200" color="grey600">
          {i18n.tp('posts.visits.count', {
            count: visits,
          })}
        </Text.Normal>
      )}
    </Box>
  )
}

export default observer(Visits)
